<template>
    <section class="content-store">
        <div class="container">
            <div class="content-store-link">
                <button tag="a" @click="hasHistory()
                    ? $router.go(-1)
                    : $router.push('/')" class="btn-return">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="69" height="69" viewBox="0 0 69 69">
                        <defs>
                            <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                            <stop offset="0" stop-color="#fece09"/>
                            <stop offset="1" stop-color="#f5891f"/>
                            </linearGradient>
                            <filter id="Ellipse_2" x="0" y="0" width="69" height="69" filterUnits="userSpaceOnUse">
                            <feOffset dy="6" input="SourceAlpha"/>
                            <feGaussianBlur stdDeviation="6" result="blur"/>
                            <feFlood flood-opacity="0.161"/>
                            <feComposite operator="in" in2="blur"/>
                            <feComposite in="SourceGraphic"/>
                            </filter>
                        </defs>
                        <g id="Group_2353" data-name="Group 2353" transform="translate(-18 -43)">
                            <g transform="matrix(1, 0, 0, 1, 18, 43)" filter="url(#Ellipse_2)">
                            <circle id="Ellipse_2-2" data-name="Ellipse 2" cx="16.5" cy="16.5" r="16.5" transform="translate(18 12)" fill="url(#linear-gradient)"/>
                            </g>
                            <path id="Union_1" data-name="Union 1" d="M11.562,0h.723V12.285h-.723V.723H0V0Z" transform="translate(55.187 79.873) rotate(-135)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                        </g>
                    </svg>
                    <h3>Estabelecimentos Aderentes</h3>
                </button>
            </div>
            <!-- Barras de pesquisa -->
            <div class="search-bars">
                <div class="search-bars-name">
                    <div>
                        <input type="text" v-model="searchByName" placeholder="Pesquisar por nome" class="search-input-wide">
                        <img src="../assets/img/icons/search.png" alt="Search Icon" class="search-icon">
                    </div>
                </div>
                <div class="search-bars-cep">
                    <div>
                        <input type="text" v-model="searchByPostalCode" placeholder="Código postal" class="search-input-narrow">
                        <img src="../assets/img/icons/search.png" alt="Search Icon" class="search-icon">
                    </div>
                </div>
            </div>

            <!-- Lista de estabelecimentos -->
            <div class="content-stores-list">
                <div v-for="(store, index) in filteredStores" :key="index" class="content-stores-list-item">
                    <div class="content-stores-list-item-info">
                        <h3>{{ store.nome }}</h3>
                        <h3>{{ store.codigo_postal }}</h3>
                    </div>
                </div>
            </div>
        </div>  
    </section>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            contentStores: [],
            searchByName: '',
            searchByPostalCode: ''
        };
    },
    methods: {
        hasHistory() {
            return window.history.length > 1;
        },
        
        async getStores() {
            this.$store.dispatch("setIsLoadingApi", true);
            try {
                const response = await axios.get('/api/v1/stores');
                this.contentStores = response.data;
                this.$store.dispatch("setIsLoadingApi", false);
            } catch (error) {
                console.error(error);
                this.$store.dispatch("setIsLoadingApi", false);
            }
        }
    },
    computed: {
        ...mapGetters(['isLoadingApi']),
        filteredStores() {
            const nameFilter = this.searchByName.toLowerCase().trim();
            const postalCodeFilter = this.searchByPostalCode.toLowerCase().trim();

            return this.contentStores.filter(store => {
                const matchName = store.nome.toLowerCase().includes(nameFilter);
                const matchPostalCode = store.codigo_postal.toLowerCase().includes(postalCodeFilter);

                return matchName && matchPostalCode;
            });
        }
    },
    mounted() {
        this.getStores();
    }
};
</script>

<style lang="scss" scoped>
.content-store {
    margin-top: 190px;
    height: 600px;
    &-link {
        button {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            background: 0;
            border: 0;
            margin-left: -25px;
            h3{
                text-align: left;
            }
        }
    }

    .search-bars {
        display: flex;
        margin: 20px auto;
        flex-direction: row;
        @media screen and (max-width: 991px){
            width: 100%;  
            flex-direction: column;  
            gap: 20px;            
        }
        &-name{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 50%;
            @media screen and (max-width: 991px){
                width: 100%;                
            }
            > div {
                position: relative;
                width: 480px;
                @media screen and (max-width: 991px){
                    width: 100%;                
                }
            }
        }
        &-cep{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 50%;
            @media screen and (max-width: 991px){
                width: 100%;                
            }
            > div {
                position: relative;
                width: 300px;
                @media screen and (max-width: 991px){
                    width: 100%;                
                }
            }
        }

        input {
            width: 100%;
            background-color: #fff;
            height: 56px;
            padding: 0 40px 0 20px; /* Ajustado o padding para deixar espaço para o ícone */
            border: 1px solid #B8B8B8;
            border-radius: 10px;
            font-size: 18px;
            font-family: 'Font Regular';
            color: #000;
            width: 100%;

            &::placeholder {
                color: #B8B8B8;
            }
        }

        .search-icon {
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            width: 24px;
            height: 24px;
            cursor: pointer;
        }
    }
    .content-stores-list {
        display: flex;
        flex-wrap: wrap;
        margin: 50px auto 100px auto;
        overflow-y: auto;
        max-height: 350px;
        @media screen and (max-width: 991px){
            max-height: 300px;
        }
        &::-webkit-scrollbar {
            width: 10px;
        }
        &::-webkit-scrollbar-track {
            background: #fff;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #C3100D;
            border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb:hover {
            background-color: #C3100D;
        }
    }

    .content-stores-list-item {
        width: 100%;
        box-sizing: border-box;
        padding: 5px 0px;
        text-align: left;
        display: flex;
        flex-direction: column;
        @media screen and (max-width: 991px){
            padding-bottom: 20px;
        }
        &-info{
            display: flex;
            flex-direction: row;
            @media screen and (max-width: 991px){
                flex-direction: column;
            }
            h3 {
                padding-left: 10px;
                max-width: 50%;
                width: 50%;
                font-size: 18px;
                font-family: 'Font Regular';
                color: #202620;
            }
        
        }

    }

    .column-2 {
        margin-left: auto;
    }

    /* Estilos para tamanhos de tela menores */
    @media (max-width: 991px) {
        .content-stores-list-item {
            width: 100%;
            margin-left: 0 !important;
        }

        .column-2 {
            margin-left: 0 !important;
        }
    }
}
</style>